module.exports = __webpack_public_path__ + "img/62.93bb4f52.jpg";